<script lang="ts">
  import type { Snippet } from "svelte";

  let {
    label = "",
    error = "",
    hint = "",
    required = false,
    class: cls = "",
    children,
  }: {
    label?: string;
    error?: string;
    hint?: string;
    required?: boolean;
    class?: string;
    children?: Snippet;
  } = $props();
</script>

<div class="flex flex-col gap-1.5 {cls}">
  {#if label}
    <span class="text-sm font-medium text-gray-300">
      {label}
      {#if required}<span class="text-red-400 ml-0.5">*</span>{/if}
    </span>
  {/if}

  {#if children}
    {@render children()}
  {/if}

  {#if error}
    <p class="text-xs text-red-400">{error}</p>
  {:else if hint}
    <p class="text-xs text-gray-500">{hint}</p>
  {/if}
</div>
